import React from 'react';

const OrderDetails = ({ orderStatus, renderStatusIcon }) => {
    return (
        <div className="order-details">
            <div className="order-info">
                <p><strong>Order ID:</strong> {orderStatus.orderId}</p>
                <p><strong>Status:</strong> {orderStatus.status} {renderStatusIcon(orderStatus.status)}</p>
                <p><strong>Order Date:</strong> {new Date(orderStatus.orderCreateDate).toLocaleString()}</p>
                <p><strong>Total Amount:</strong> {(orderStatus.totalAmount / 100).toFixed(2)} {orderStatus.currencyCode}</p>
                <p><strong>Buyer:</strong> {orderStatus.buyer?.firstName} {orderStatus.buyer?.lastName}</p>
                <p><strong>Email:</strong> {orderStatus.buyer?.email}</p>
                <p><strong>Phone:</strong> {orderStatus.buyer?.phone}</p>
                <p><strong>Products:</strong></p>
                <ul>
                    {orderStatus.products.map((product, index) => (
                        <li key={index}>{product.name} - {product.quantity} x {(product.unitPrice / 100).toFixed(2)} {orderStatus.currencyCode}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default OrderDetails;
